import { Controller } from "@hotwired/stimulus";
import moment from "moment";

export default class extends Controller {
  static get targets() {
    return ["startDisplay", "endDisplay", "startHidden", "endHidden"];
  }

  static get values() {
    return {
      startInitial: String,
      endInitial: String,
    };
  }

  connect() {
    const startIso = this.startInitialValue || this.defaultIso();
    const endIso = this.endInitialValue || startIso;

    this.startHiddenTarget.value = startIso;
    this.endHiddenTarget.value = endIso;
    this.startDisplayTarget.value = this.formatUtcForInput(startIso);
    this.endDisplayTarget.value = this.formatUtcForInput(endIso);

    this.endDisplayTarget.removeAttribute("min");
  }

  updateStart() {
    const startIso = this.isoFromInputUtc(this.startDisplayTarget.value);

    if (!startIso) {
      return;
    }

    this.startHiddenTarget.value = startIso;

    const endMoment = moment.utc(this.endHiddenTarget.value);
    const startMoment = moment.utc(startIso);

    if (!endMoment.isValid() || endMoment.isBefore(startMoment)) {
      this.endHiddenTarget.value = startIso;
      this.endDisplayTarget.value = this.formatUtcForInput(startIso);
    }
  }

  updateEnd() {
    const endIso = this.isoFromInputUtc(this.endDisplayTarget.value);
    const endMoment = moment.utc(endIso);
    const startMoment = moment.utc(this.startHiddenTarget.value);

    if (
      !endMoment.isValid() ||
      !startMoment.isValid() ||
      endMoment.isBefore(startMoment)
    ) {
      this.endDisplayTarget.value = this.formatUtcForInput(
        this.endHiddenTarget.value,
      );
      return;
    }

    this.endHiddenTarget.value = endIso;
  }

  formatUtcForInput(value) {
    const parsed = moment.utc(value);
    return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : "";
  }

  isoFromInputUtc(value) {
    const parsed = moment.utc(value, "YYYY-MM-DDTHH:mm", true);
    return parsed.isValid() ? parsed.toISOString() : "";
  }

  defaultIso() {
    return moment.utc().add(1, "hour").startOf("hour").toISOString();
  }
}
